var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "stats-row", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon total" }, [
                      _c("i", { staticClass: "el-icon-message" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.total)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Total Notifications"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon sent" }, [
                      _c("i", { staticClass: "el-icon-success" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.sent)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Sent"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon failed" }, [
                      _c("i", { staticClass: "el-icon-error" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.failed)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Failed"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon pending" }, [
                      _c("i", { staticClass: "el-icon-loading" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.pending)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Pending"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon day" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.stats.last24Hours)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Last 24 Hours"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    { staticClass: "stat-content" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.showTestDialog },
                        },
                        [_vm._v(" Test Notification ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Status", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", { attrs: { label: "Sent", value: "sent" } }),
              _c("el-option", { attrs: { label: "Failed", value: "failed" } }),
              _c("el-option", {
                attrs: { label: "Pending", value: "pending" },
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { placeholder: "Type", clearable: "" },
              model: {
                value: _vm.listQuery.notificationType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "notificationType", $$v)
                },
                expression: "listQuery.notificationType",
              },
            },
            [
              _c("el-option", {
                attrs: {
                  label: "Expiry 30 Days",
                  value: "subscription_expiry_30d",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: "Expiry 7 Days",
                  value: "subscription_expiry_7d",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: "Expiry 1 Day",
                  value: "subscription_expiry_1d",
                },
              }),
              _c("el-option", {
                attrs: { label: "Expired", value: "subscription_expired" },
              }),
              _c("el-option", {
                attrs: { label: "Admin Test", value: "admin_test" },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "User ID", clearable: "" },
            model: {
              value: _vm.listQuery.userId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "userId", $$v)
              },
              expression: "listQuery.userId",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.handleRefresh },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            _vm._l(_vm.stats.byType, function (count, type) {
              return _c(
                "el-tag",
                {
                  key: type,
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: _vm.getNotificationTypeTag(type) },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatNotificationType(type)) +
                      ": " +
                      _vm._s(count) +
                      " "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.logs,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", align: "center", width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Type", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getNotificationTypeTag(
                            row.notificationType
                          ),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatNotificationType(row.notificationType)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTag(row.status),
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.status) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "User", align: "left", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.userEmail || "N/A"))]),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "11px", color: "#909399" },
                      },
                      [_vm._v(_vm._s(row.userId))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Title", align: "left", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.title) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Message", align: "left", "min-width": "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: row.message, placement: "top" } },
                      [
                        _c("span", { staticClass: "message-text" }, [
                          _vm._v(_vm._s(row.message)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Provider", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                      _vm._v(_vm._s(row.provider)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Created", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(row.createdAt)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status === "failed"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-refresh-right",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.retryNotification(row)
                              },
                            },
                          },
                          [_vm._v(" Retry ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showDetails(row)
                          },
                        },
                      },
                      [_vm._v(" Details ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.listQuery.pageSize,
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Notification Details",
            visible: _vm.detailsDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "", size: "small" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.selectedLog.id)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Type" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getNotificationTypeTag(
                          _vm.selectedLog.notificationType
                        ),
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatNotificationType(
                              _vm.selectedLog.notificationType
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Status" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusTag(_vm.selectedLog.status),
                        size: "small",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.selectedLog.status) + " ")]
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Provider" } }, [
                _vm._v(_vm._s(_vm.selectedLog.provider)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "User ID" } }, [
                _vm._v(_vm._s(_vm.selectedLog.userId)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "User Email" } }, [
                _vm._v(_vm._s(_vm.selectedLog.userEmail || "N/A")),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Title", span: 2 } },
                [_vm._v(_vm._s(_vm.selectedLog.title))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Message", span: 2 } },
                [_vm._v(_vm._s(_vm.selectedLog.message))]
              ),
              _c("el-descriptions-item", { attrs: { label: "Reference ID" } }, [
                _vm._v(_vm._s(_vm.selectedLog.referenceId || "N/A")),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Reference Type" } },
                [_vm._v(_vm._s(_vm.selectedLog.referenceType || "N/A"))]
              ),
              _c("el-descriptions-item", { attrs: { label: "Created At" } }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.selectedLog.createdAt))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Sent At" } }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.selectedLog.sentAt) || "N/A")),
              ]),
              _vm.selectedLog.errorMessage
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: "Error", span: 2 } },
                    [
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v(_vm._s(_vm.selectedLog.errorMessage)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Send Test Notification",
            visible: _vm.testDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.testDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.testForm, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "User ID", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Enter user ID" },
                    model: {
                      value: _vm.testForm.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.testForm, "userId", $$v)
                      },
                      expression: "testForm.userId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Test Notification" },
                    model: {
                      value: _vm.testForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.testForm, "title", $$v)
                      },
                      expression: "testForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Message" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder:
                        "This is a test notification from WeWalk Admin",
                    },
                    model: {
                      value: _vm.testForm.message,
                      callback: function ($$v) {
                        _vm.$set(_vm.testForm, "message", $$v)
                      },
                      expression: "testForm.message",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.testDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.testLoading },
                  on: { click: _vm.sendTestNotification },
                },
                [_vm._v(" Send ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }